export const Gift_OCCASION_IMAGES_FETCH = "GiftOCCASIONIMAGESFETCH";
export const Gift_OCCASION_REQUEST = "GiftOCCASIONREQUEST";
export const Gift_OCCASION_SUCCESS = "GiftOCCASIONSUCCESS";
export const Gift_OCCASION_IMAGES_REQUEST = "GiftOCCASIONIMAGESREQUEST";
export const Gift_OCCASION_IMAGES_SUCCESS = "GiftOCCASIONIMAGESSUCCESS";